import type { Problem } from '@/services/types/Problem';

/**
 * The administration's password session (ADM-1), as far as the SPA has to know it.
 *
 * A login with a temporary password answers `mustChangePassword`, and until it is changed every
 * administration route answers 403 with the code admin.auth.password_change_required. That code is
 * what sends the tab to the password page — not a mark the tab kept from its login, which a second
 * tab, a cleared storage or a password changed elsewhere would leave wrong.
 */

export const ADMIN_LOGIN_PATH = '/admin/autentificare';
export const ADMIN_PASSWORD_PATH = '/admin/parola';

export const PASSWORD_CHANGE_REQUIRED = 'admin.auth.password_change_required';

/** Whether a 403 is the "change your temporary password first" refusal. */
export function isPasswordChangeRefusal(problem: Pick<Problem, 'code'>): boolean {
  return problem.code === PASSWORD_CHANGE_REQUIRED;
}
